import React from 'react';
import { cn } from '@/lib/utils';
import { useTestSuiteTypeColor } from '@/app/features/reports/ratingHelpers';
import { Button } from '@/components/ui/button';
import { RatingTypes } from 'store/src/lib/services/types';
import { useReportViewContext } from '../report-viewer-context';

interface ExpanderTriggerProps {
    handleExpandTile: () => void;
    ratingType: RatingTypes;
    isTileExpanded: boolean;
    className?: string;
}

const ExpanderTrigger: React.FC<ExpanderTriggerProps> = ({
    handleExpandTile,
    ratingType,
    isTileExpanded,
    className
}) => {
    const { viewId } = useReportViewContext()
    const isPrintMode = viewId === 'print'

    // Don't render expander in print mode
    if (isPrintMode) {
        return null
    }

    return (
        <div className={cn(
            "w-full text-left text-zinc-950 dark:text-zinc-50 px-4 py-2",
            className
        )}>
            <div className="flex flex-1 flex-row text-sm p-0 items-center">
                <Button
                    variant='link'
                    className="px-0 py-0"
                    style={{ color: useTestSuiteTypeColor(ratingType) }}
                    onClick={handleExpandTile}
                    aria-expanded={isTileExpanded}
                    aria-label={isTileExpanded ? "Collapse tile content" : "Expand tile content"}
                >
                    {isTileExpanded ? (
                        <span className="font-normal tracking-tight">Show less...</span>
                    ) : (
                        <span className="font-normal tracking-tight">Show more...</span>
                    )}
                </Button>
            </div>
        </div>
    );
};

export default ExpanderTrigger;
